import React from 'react';

/**
 * LinkifyText - Renders text with auto-detected URLs as clickable links.
 * Safe alternative to dangerouslySetInnerHTML — only URLs become links.
 */
const URL_REGEX = /(https?:\/\/[^\s<>"')\]]+)/gi;
const URL_TEST = /^https?:\/\//i;

const LinkifyText = ({ text, className = '' }) => {
  if (!text) return null;

  const parts = text.split(URL_REGEX);
  
  return (
    <span className={className}>
      {parts.map((part, i) =>
        URL_TEST.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline break-all"
          >
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </span>
  );
};

export default LinkifyText;
